export default {"src":"/_next/static/media/ladder.40c6f2c3.svg","height":48,"width":150,"blurWidth":0,"blurHeight":0};